define('CustomProductCollection.RenderHelper', [], function CustomProductCollectionRenderHelper() {
    'use strict';

    /**
     * Utility functions for deciding UI render eligibility for custom product collection views.
     * Encapsulates mixed logic previously found in helpers for maintainability.
     * @module CustomProductCollection.RenderHelper
     */

    /**
     * Determines if the child view can be rendered based on item information and model data.
     * @param {Object} contextDataItem
     * @param {Object} customProductCollectionModel
     * @returns {boolean}
     */
    function canRenderChildView(contextDataItem, customProductCollectionModel) {
        return (
            contextDataItem &&
            customProductCollectionModel &&
            String(contextDataItem.internalid) === String(customProductCollectionModel.get('parentItem')) &&
            customProductCollectionModel.get('childrenItemData')
        );
    }

    /**
     * @returns {Object} Utility API for UI eligibility logic
     */
    return {
        canRenderChildView: canRenderChildView
    };
});
